import { fetchManager } from '../utils/fetchManager';

export const settingsService = {
  loadSettingsList: () => fetchManager('get', 'settings'),
  updateSettings: (settingId, setting) => fetchManager('put', `settings/${settingId}`, setting),
  cleanup: () => fetchManager('delete', 'cleanup'),
};
